import React from "react"

export default function Recruiting() {
  return (
    <div id="recuriting" class="gradient pb-32">
      <svg
        class="wave-top"
        viewBox="0 0 1439 147"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-1.000000, -14.000000)" fill-rule="nonzero">
            <g class="wave" fill="#FFFFFF">
              <path d="M1440,84 C1383.555,64.3 1342.555,51.3 1317,45 C1259.5,30.824 1206.707,25.526 1169,22 C1129.711,18.326 1044.426,18.475 980,22 C954.25,23.409 922.25,26.742 884,32 C845.122,37.787 818.455,42.121 804,45 C776.833,50.41 728.136,61.77 713,65 C660.023,76.309 621.544,87.729 584,94 C517.525,105.104 484.525,106.438 429,108 C379.49,106.484 342.823,104.484 319,102 C278.571,97.783 231.737,88.736 205,84 C154.629,75.076 86.296,57.743 0,32 L0,0 L1440,0 L1440,84 Z"></path>
            </g>
            <g transform="translate(1.000000, 15.000000)" fill="#FFFFFF">
              <g transform="translate(719.500000, 68.500000) rotate(-180.000000) translate(-719.500000, -68.500000) ">
                <path
                  d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                  opacity="0.100000001"
                ></path>
                <path
                  d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                  opacity="0.100000001"
                ></path>
                <path
                  d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                  opacity="0.200000003"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>

      <section class="container mx-auto text-center py-6">
        <h1 class="w-full my-2 text-4xl font-bold leading-tight text-center text-white">
          募集案内
        </h1>
        <div class="w-full mb-4">
          <div class="h-1 mx-auto bg-white w-1/6 opacity-25 rounded-t"></div>
        </div>

        <p class="mx-10 my-10 text-lg leading-tight">
          現在プログラミングを学びたい生徒様を募集中です。現在のところ個別指導を予定しておりますが、申し込みの人数次第では２〜3人または集団での講義になることをご了承ください。
        </p>
        <li class="mx-10 my-4 text-base text-left leading-tight">
          <b>対象</b>
          ：Web開発、プログラミングに興味のある中学生、高校生、社会人の方
        </li>
        <li class="mx-10 my-4 text-base text-left leading-tight">
          <b>場所</b>
          ：都城市立図書館の施設内スペース（人数によって会議室、コワーキングスペースを利用）
        </li>
        <li class="mx-10 my-4 text-base text-left leading-tight">
          <b>必要なもの</b>：ノートパソコン　※用意できない場合はご相談ください
        </li>
        <li class="mx-10 my-4 text-base text-left leading-tight">
          <b>主な使用言語</b>：React、Python
        </li>
        <p class="mx-10 my-4 text-base text-left leading-tight">
          ※
          講座では英語を多用します。丁寧に英語指導もできますので、苦手でも大丈夫ですよ！
        </p>
        <p class="mx-10 my-4 text-base text-left leading-tight">
          ※ 月に2回だけ受講したいなどの受講回数の相談は柔軟に対応いたします。
        </p>

        <h1 id="contact" class="text-4xl font-bold pt-8 mt-8">
          お問い合わせ
        </h1>
        <div class="mx-auto w-2/5 pt-3 border-b-2 border-teal-5 text-blue-200 opacity-25"></div>
        <p class="mx-10 my-10 text-lg leading-tight">
          LINEによるお問い合わせを受け付けております。下記IDでLINE検索もしくは画像から
          "CodeWithMe!とくみつ" を追加してください。
        </p>
        <li class="mx-10 my-4 text-base text-left leading-tight">
          <b>LINEID</b>
          ：@984hymoc
        </li>

        <a href="https://lin.ee/iiPozpi">
          <img
            className=" mt-12 ml-12"
            src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png"
            alt="友だち追加"
          />
        </a>
      </section>
    </div>
  )
}
